// extracted by mini-css-extract-plugin
module.exports = {"aside":"columnsGrid-module--aside--1-K2O","grid":"columnsGrid-module--grid--3_nvw","content":"columnsGrid-module--content--1IxYK"};